import { useMemo } from 'react';

import { useAppSelector } from '@/store/hooks';
import { selectSessionByUuid } from '@/store/slices/project/selectors';
import useParamsOrFirstSessionUuid from '@/utils/use-params-or-first-session-uuid';

const useSelectSessionCrew = () => {
  const sessionUuid = useParamsOrFirstSessionUuid();

  const session = useAppSelector(selectSessionByUuid(sessionUuid));

  return useMemo(() => {
    if (!session) return [];
    return session?.crew || [];
  }, [session]);
};

export default useSelectSessionCrew;
